module.exports = __webpack_public_path__ + "img/22.a55bcc61.png";